var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalCaptures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 15.1667V18.6667H5.83333V21H0V15.1667H2.33333ZM21 15.1667V21H15.1667V18.6667H18.6667V15.1667H21ZM10.5 4.66667C13.7217 4.66667 16.3333 7.27834 16.3333 10.5C16.3333 13.7217 13.7217 16.3333 10.5 16.3333C7.27834 16.3333 4.66667 13.7217 4.66667 10.5C4.66667 7.27834 7.27834 4.66667 10.5 4.66667ZM21 0V5.83333H18.6667V2.33333H15.1667V0H21ZM5.83333 0V2.33333H2.33333V5.83333H0V0H5.83333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCaptures);
export default __webpack_public_path__ + "static/media/total_captures.4e82c153484f5331d2fce1ad5b7cdedf.svg";
export { ForwardRef as ReactComponent };